export function sortData<T>(data: T[], sortKey: keyof T): T[] {
    return data.sort((a, b) => {
        if (typeof a[sortKey] !== 'string') {
            throw new Error('Sort by string values only');
        }
        // Ignore upper and lowercase
        const aValue = String(a[sortKey]).toUpperCase();
        const bValue = String(b[sortKey]).toUpperCase();
        if (aValue < bValue) {
            return -1;
        }
        if (aValue > bValue) {
            return 1;
        }
        return 0;
    });
}

export function debounce(func: Function, wait: number) {
    let timeoutId: number | undefined;

    return function debouncedFunction(this: any, ...args: any[]) {
        const context = this;

        const later = () => {
            console.log('later', timeoutId);
            timeoutId = undefined;
            func.apply(context, args);
        };

        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(later, wait);
    };
}

export const checkValidUrl = (url: string): Promise<boolean> =>
    new Promise((resolve) => {
        fetch(url)
            .then((response) => {
                resolve(response.status === 200);
            })
            .catch((error) => {
                resolve(false);
            });
    });
